__turbopack_context__.v({
  "className": "inter_f940b371-module__30aXjW__className",
  "variable": "inter_f940b371-module__30aXjW__variable",
});
